import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DetailedRegistration} from '../datamodel/registration';
import {LeftMenuService} from '../left-menu.service';
import {Langdict} from '../datamodel/langdict';

@Component({
  selector: 'app-courses-groups',
  templateUrl: './courses-groups.component.html',
  styleUrls: ['./courses-groups.component.css']
})
export class CoursesGroupsComponent implements OnInit {

  registration: DetailedRegistration;
  allId: string;

  constructor(public route: ActivatedRoute, public menu: LeftMenuService, public router: Router) {
  }

  ngOnInit() {
    this.allId = '_';

    this.registration = this.route.snapshot.data.registration as DetailedRegistration;
    this.menu.addPath([this.registration]);
    if (this.registration.coursesGroups.length === 0) {
      if (this.route.snapshot.queryParams.back) {
        setTimeout(() => this.router.navigate(['/']));
      }
      setTimeout(() => this.router.navigate([this.allId], { relativeTo: this.route }));
    }
  }
}
